{
  "title": "Settings",
  "description": "Manage your account information, security, and preferences",
  "accountInfo": {
    "title": "Account Information",
    "accountId": "Account ID",
    "fullName": "Full Name",
    "email": "Email",
    "country": "Country",
    "companyCut": "Fees",
    "tenure": "Tenure",
    "immutable": "Immutable",
    "unitedStates": "United States",
    "editButton": "Edit",
    "editModal": {
      "title": "Edit Profile",
      "fullNameLabel": "Full Name",
      "fullNamePlaceholder": "Enter your full name",
      "fullNameRequired": "Please enter your full name",
      "emailLabel": "Email",
      "emailPlaceholder": "Enter your email",
      "emailRequired": "Please enter your email",
      "emailInvalid": "Please enter a valid email address",
      "cancelButton": "Cancel",
      "saveButton": "Save Changes",
      "success": "Profile updated successfully",
      "error": "Failed to update profile"
    }
  },
  "security": {
    "title": "Security",
    "changePassword": {
      "title": "Change Password",
      "requirements": {
        "title": "Password Requirements",
        "minLength": "At least 8 characters long",
        "complexity": "Must contain at least 3 of the following: lowercase letter, uppercase letter, number, special character"
      },
      "currentPassword": {
        "label": "Current Password",
        "placeholder": "Enter current password",
        "required": "Please enter your current password"
      },
      "newPassword": {
        "label": "New Password",
        "placeholder": "Enter new password",
        "required": "Please enter a new password",
        "minLength": "Password must be at least 8 characters long"
      },
      "confirmPassword": {
        "label": "Confirm New Password",
        "placeholder": "Confirm new password",
        "required": "Please confirm your new password",
        "mismatch": "Passwords do not match"
      },
      "button": "Change Password",
      "success": "Password changed successfully",
      "error": "Failed to change password"
    }
  },
  "preferences": {
    "title": "Preferences",
    "language": {
      "title": "Language",
      "english": "English",
      "spanish": "Español",
      "saveButton": "Save",
      "success": "Language updated successfully",
      "error": "Failed to update language"
    },
    "emailNotifications": {
      "title": "Email Notifications",
      "description": "Manage which email notifications you receive",
      "masterToggle": "Enable all email notifications",
      "profitAllocation": "Profit allocations",
      "profitAllocationDesc": "Receive notifications when profits are allocated to your account",
      "weeklySettlement": "Weekly settlements",
      "weeklySettlementDesc": "Receive weekly summary of your profit settlements and reinvestments",
      "withdrawalStatus": "Withdrawal status updates",
      "withdrawalStatusDesc": "Notifications about your withdrawal request status changes",
      "adminUpdates": "Admin updates",
      "adminUpdatesDesc": "Important updates and announcements from administrators",
      "saveButton": "Save Preferences",
      "success": "Email notification preferences updated",
      "error": "Failed to update notification preferences"
    }
  },
  "accountManagement": {
    "title": "Account Management",
    "closureCancelSuccess": "Account closure request cancelled",
    "closureCancelError": "Failed to cancel closure request",
    "exportData": {
      "title": "Export Data",
      "comingSoon": "Export your account data and transaction history. (Coming soon)"
    }
  },
  "monthlyStatements": {
    "title": "Monthly Statements",
    "generateNew": "Generate New Statement",
    "description": "Generate an itemized monthly statement showing all contributions, profit allocations, settlements, and withdrawals for the selected period.",
    "yourStatements": "Your Statements",
    "generateButton": "Generate Statement",
    "downloadButton": "Download",
    "period": "Period",
    "status": "Status",
    "generated": "Generated",
    "action": "Action",
    "statusReady": "Ready",
    "statusFailed": "Failed",
    "statusGenerating": "Generating",
    "generationFailed": "Generation failed",
    "generatingText": "Generating...",
    "noStatements": "No statements generated yet",
    "futureMonthWarning": "Cannot generate statements for future months",
    "generateSuccess": "Monthly statement generated successfully",
    "generateError": "Failed to generate statement",
    "downloadError": "Failed to download statement",
    "loadError": "Failed to load statements",
    "months": {
      "january": "January",
      "february": "February",
      "march": "March",
      "april": "April",
      "may": "May",
      "june": "June",
      "july": "July",
      "august": "August",
      "september": "September",
      "october": "October",
      "november": "November",
      "december": "December"
    }
  },
  "buttons": {
    "save": "Save"
  },
  "messages": {
    "loadError": "Failed to load profile data",
    "incomeUpdateSuccess": "Annual income updated successfully",
    "incomeUpdateError": "Failed to update annual income"
  },
  "privacy": {
    "link": "Privacy Policy"
  },
  "terms": {
    "link": "Terms and Conditions"
  }
}
